<template>
	<div class="newListDiv margin-t50">
        <div class="top_title wow fadeInUp" data-wow-delay="0.2s">
      <div class="top_text">
        <p>学术交流</p>
        <span>ACADEMIC EXCHANGE</span>
      </div>
      <div v-if="moreLink" class="more wow zoomIn" data-wow-delay="0.3s">
        <router-link :to="moreLink"><em>查看更多>></em></router-link>
      </div>
    </div>
    <ul>
      <li
        v-for="(item, index) in xsjlList"
        :key="item.ID"
        @mouseenter="hoverRoll(item)"
        class="wow fadeInLeft"
        :data-wow-delay="index / 5 + 's'"
      >
        <router-link
          :to="item.Url"
          :href="item.Url"
          @click.native="OpenLink(item.Url)"
        >
          <div class="textBox">
            <p class="title txt-cut1">{{ item.Title }}</p>
          </div>
          <div class="time">
            {{ setTimeformat(item.ShowTime6, "yyyy-mm-dd") }}
          </div>
        </router-link>
      </li>
    </ul>
	</div>
</template>

<script>
	export default{
		name:'xsjl',
		props:{
			xsjlList:{
				type:Array,
				default:()=>[]
			},
			moreLink: {
			   type: String,
			   default: ''
			},
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>

<style lang='less' scoped>
.newListDiv{
	.top_title {
    width: 6.9rem;
    height: 1.1rem;
    background-color: #f9f9f9;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    margin-bottom: 0.25rem;
	.top_text {
		padding-left: 0.4rem;
		position: relative;
		&::before {
		content: "";
		position: absolute;
		width: 0.02rem;
		height: 100%;
		background-color: #32454f;
		left: 0.3rem;
		}
		p {
		font-size: 0.26rem;
		font-weight: 600;
		font-stretch: normal;
		line-height: 0.26rem;
		letter-spacing: 0.02rem;
		color: #32454f;
		margin-bottom: 0.1rem;
		}
		span {
		font-size: 0.16rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 0.2rem;
		letter-spacing: 0rem;
		color: #32454f;
		display: block;
		}
	}
	.more > a {
		display: block;
		margin-top: 0.27rem;
		font-size: 0.24rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 0.26rem;
		letter-spacing: 0rem;
		color: #333333;
		padding-right: 0.36rem;
	}
  }
  ul {
  width: 100%;
  height: auto;
  display: inline-block;
  vertical-align: top;
  padding: 0rem 0.36rem 0rem 0.3rem;
  box-sizing: border-box;
  li {
  width: 100%;
  height: 0.4rem;
  margin-bottom: 0.25rem;
  font-size: 0;
  border-bottom: dashed 0.01rem #e4e4e4;
  box-sizing: border-box;
  &:last-child {
	margin-bottom: 0rem;
	}
	a {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
	.time {
		display: block;
		font-size: 0.24rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 0.26rem;
		letter-spacing: 0.01rem;
		color: #666666;
		}
		.textBox {
		width: 4rem;
		display: inline-block;
		font-size: 0.26rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: 0.26rem;
		letter-spacing: 0.02rem;
		color: #333333;
		padding-left: 0.15rem;
		box-sizing: border-box;
		position: relative;
		p{
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		&::before {
		content: "";
		width: 0.06rem;
		height: 0.06rem;
		background-color: #0376be;
		border-radius: 50%;
		display: block;
		position: absolute;
		top: 0.1rem;
		left: 0rem;
		}
	}
	}
   }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xsjl.vue